import React from "react";
import greater from "../images/greater.svg";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  // Calculate which page numbers to show
  const getPageNumbers = () => {
    const pages = [];

    // Always show first page
    pages.push(1);

    // Calculate range around current page
    let startPage = Math.max(2, currentPage - 1);
    let endPage = Math.min(totalPages - 1, currentPage + 1);

    // Add ellipsis after first page if needed
    if (startPage > 2) {
      pages.push("ellipsis-start");
    }

    // Add pages around current page
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    // Add ellipsis before last page if needed
    if (endPage < totalPages - 1) {
      pages.push("ellipsis-end");
    }

    // Always show last page if there's more than one page
    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="mt-5">
      <div className="flex flex-wrap gap-2 xl:gap-[13px] justify-center items-center">
        {/* Previous button */}
        <div
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          className={`${
            currentPage === 1
              ? "opacity-50 cursor-not-allowed"
              : "cursor-pointer"
          }`}
        >
          <img
            src={greater}
            alt="previous"
            className="object-contain rotate-180 dark:brightness-[100] dark:hover:brightness-50"
          />
        </div>

        {/* Page numbers */}
        {getPageNumbers().map((page, index) => {
          if (page === "ellipsis-start" || page === "ellipsis-end") {
            return (
              <div
                key={`ellipsis-${index}`}
                className="rounded-[4px] size-5 xl:size-8 text-[#555752] text-xs xl:text-sm font-semibold dark:text-white flex justify-center items-center"
              >
                ...
              </div>
            );
          }

          return (
            <div
              key={page}
              onClick={() => onPageChange(page)}
              className={`rounded-[4px] cursor-pointer size-5 xl:size-8 text-xs xl:text-sm font-semibold flex justify-center items-center transition-all duration-300
                ${
                  currentPage === page
                    ? "bg-darkblue dark:bg-white text-white dark:text-darkblue"
                    : "text-[#555752] dark:bg-bluedarkmode dark:hover:bg-white bg-darkblue/10 dark:hover:text-darkblue dark:text-white hover:text-white hover:bg-darkblue"
                }`}
            >
              {page}
            </div>
          );
        })}

        {/* Next button */}
        <div
          onClick={() =>
            currentPage < totalPages && onPageChange(currentPage + 1)
          }
          className={`${
            currentPage === totalPages
              ? "opacity-50 cursor-not-allowed"
              : "cursor-pointer"
          }`}
        >
          <img
            src={greater}
            alt="next"
            className="object-contain dark:brightness-[100] dark:hover:brightness-50"
          />
        </div>
      </div>
    </div>
  );
};

export default Pagination;
